import React, { useEffect } from "react";
import { Input } from "antd";
import { Controller } from "react-hook-form";
import { getRegexForValidation } from "../../utils/getRegexForValidation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "../../utils/fa-icons-map";
interface Props {
  title: string;
  placeholder: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  rules?: any;
  setValue?: any;
  setError?: any;
  control?: any;
  name: string;
  pattern?: any;
  onBlur?: any;
  icon?:string;
}
const InputUnControlledComponent: React.FC<Props> = ({
  title,
  placeholder,
  onChange,
  disabled,
  data,
  className,
  setValue,
  setError,
  rules,
  control,
  name,
  pattern,
  onBlur,
  icon
}) => {


  useEffect(() => {
    if (data !== undefined && data !== null && data.toString().length > 0) {
      setValue(name, data);
      // if (onChange) {
      //   console.log("");
      //   // onChange({ target: { value: data } });
      // }
    }
  }, [data]);


  const handleTextBoxIcon = (icon: string) => {

    const fa = icons.get(icon);
    if(fa) {
      return <FontAwesomeIcon className="mr-1" style={{opacity: 0.4}} icon={fa}/>
    } else {
      return <></>
    }
    
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required:
          rules?.mandatory === true ? `${title} is required` : false,
        max: {
          value: rules?.maxValue || null,
          message: `Max value Is ${rules?.maxValue}.`
        },
        pattern: {
          value: getRegexForValidation(rules?.allowValues).value,
          message: getRegexForValidation(rules?.allowValues).message,
        },
        min: {
          value: rules?.minValue,
          message: `Min value Is ${rules?.minValue}.`
        },
        minLength: {
          value: rules?.minSize,
          message: `Min length Is ${rules?.minSize}.`
        },
        maxLength: {
          value: rules?.maxSize,
          message: `Max length Is ${rules?.maxSize}.`
        },
      }}
      render={({ field, fieldState, formState }) => (
        <>
          <Input
            suffix={icon ? handleTextBoxIcon(icon) : null}
            title={title}
            placeholder={placeholder}
            disabled={disabled}
            className={className}
            {...field}
            value={field?.value}
            name={field?.name}
            onChange={(ev: any) => {

      
              if (getRegexForValidation(rules?.allowValues).value.test(ev.target.value) ||
                ev.target.value === '' ||
                rules?.allowValues === 'rcNumber' ||
                rules?.allowValues === 'pan' ||
                rules?.allowValues === 'adhar' ||
                rules?.allowValues === 'email'
              ) {

                // Check max size
                if (rules.maxSize && ev.target.value.length > Number(rules.maxSize)) {
                  ev.target.value = ev.target.value.slice(0, Number(rules.maxSize))
                }

                // field.onChange((rules?.allowValues.toString() === "onlyDigital" || rules?.allowValues === "onlyNumeric") ? value.target.value.trimStart().trimEnd() : value.target.value.trimStart());
                field.onChange(ev.target.value.trimStart());

                // Convert letter to uppercase
                if (rules?.alwaysCapital) {
                  field.onChange(ev.target.value.trimStart().toUpperCase())
                }

                if (rules?.allowValues === "onlyNumeric" && ev.target.value === "") {
                  field.onChange(0);
                }


                if (rules?.allowValues === "onlyDigital" || rules?.allowValues === "onlyNumeric") {

                  if (ev.target.value.startsWith('0')) { //  Remove 0 from start when allowValues is onlyNumeric
                    field.onChange(ev.target.value.slice(1));
                  } else {
                    field.onChange(ev.target.value.trimStart().trimEnd());
                  }
                }

                onChange(ev);

              }
            }
            }
            onBlur={() => {
              field.onBlur();
              if (onBlur) {
                onBlur(field.value);
              }
            }}
            {...formState.defaultValues}
            maxLength={title === "email" ? 50 : (Number(rules?.maxSize) ?? 1000)}

          />
          {fieldState.error?.message && (
            <div className="ant-form-item-explain-error">
              {fieldState.error?.message}
            </div>
          )}
        </>
      )}
    />
  );
};

export { InputUnControlledComponent as InputComponent };